import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  FormLabel,
  IconButton,
  Input,
  Select,
  Spinner,
  Stack,
  Text,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";

import { CheckIcon, DownloadIcon } from "@chakra-ui/icons";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { HIds } from "../assets/hooks/HIds";
import { UserAuth } from "../auth/AuthContext";
import { getFirestoreApp } from "../firebase-config";
import PrintButton from "./PrintButton";

const initialState = {
  Carro: {
    placa: "",
    modelo: "",
    ano: "",
    filial: "",
    p_revisao: "",
    u_km_registrado: "",
    u_revisao: "",
    u_troca_pneu: "",
    status: "",
    obs: "",
  },
};

const EditCar = () => {
  const [isDisabled, setIsDisabled] = useState(false); // Desabilitar botão após submit para evitar duplicação
  const [pushdata, SetPushData] = useState(true);

  //HOOKS
  const { carroId, filialId } = HIds();
  const { user } = UserAuth();

  const firstField = React.useRef();

  //FIREBASE
  const db = getFirestoreApp;
  const docRef = doc(db, "/FILIAIS/91IYpjJbXYN99Asq2Enw/", filialId, carroId);

  const getCarInfo = async () => {
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      SetData({ ...docSnap.data() });
      console.log("Document data:", docSnap.data());
      SetPushData(false);
    } else {
      // doc.data() will be undefined in this case
      console.log("NÃO EXISTEM DOCUMENTOS!");
    }
  };

  {
    pushdata ? getCarInfo() : null;
  }

  const updateCar = async () => {
    setIsDisabled(true);
    await updateDoc(docRef, {
      ...data,
    });
    ToastExample();
    setTimeout(() => {
      setIsDisabled(false);
    }, 5000);
  };

  //TOAST
  const toast = useToast();

  //DATA SET
  const [data, SetData] = useState(initialState);
  const {
    Carro: {
      placa,
      modelo,
      ano,
      filial,
      p_revisao,
      u_km_registrado,
      u_revisao,
      u_troca_pneu,
      status,
      obs,
    },
  } = data;

  //UPLOAD FILE
  const [file, setFile] = useState(null);

  //PROGRESS, SUBMIT
  const [progress, setProgress] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);

  const ToastExample = () => {
    return toast({
      title: "Carro atualizado com sucesso!",
      position: "top-right",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const handleChange = (e) => {
    SetData({
      ...data,
      Carro: {
        ...data.Carro,
        [e.target.name]: e.target.value,
      },
    });
  };

  return (
    <>
      {isSubmit ? (
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
      ) : null}

      <Stack spacing="24px">
        {pushdata ? (
          <Button
            leftIcon={<DownloadIcon />}
            colorScheme="green"
            onClick={getCarInfo}
            size="sm"
            variant="outline"
          >
            Preencher com dados existentes
          </Button>
        ) : null}

        {pushdata ? (
          <Alert status="info" variant="left-accent">
            <AlertIcon />
            Quando for editar, sempre clique para preencher com os dados
            existentes, caso contrário, irá perder as informações atuais.
          </Alert>
        ) : null}

        <Flex justifyContent={"space-between"}>
          <Text as="b" fontSize="3xl">
            PLACA: {placa}
          </Text>
          <PrintButton />
        </Flex>

        <Box>
          {user.displayName === "franca" || user.displayName === "priscila" ? (
            <>
              <FormLabel htmlFor="placa">Editar Placa:</FormLabel>
              <Input
                type="text"
                name="placa"
                id="placa"
                value={placa}
                onChange={handleChange}
              />
            </>
          ) : null}

          <FormLabel htmlFor="modelo">Modelo:</FormLabel>
          <Input
            id="modelo"
            name="modelo"
            data-object="Carro"
            placeholder="Ex: Strada"
            variant="filled"
            value={modelo}
            onChange={handleChange}
          />
        </Box>

        <Box>
          <FormLabel htmlFor="ano">Ano:</FormLabel>
          <Input
            id="ano"
            name="ano"
            data-object="Carro"
            // placeholder="Ex: 2010 / 2011"
            variant="filled"
            value={ano}
            onChange={handleChange}
          />
        </Box>

        <Box>
          <FormLabel htmlFor="p_revisao">Próxima revisão:</FormLabel>
          <Input
            id="p_revisao"
            name="p_revisao"
            data-object="Carro"
            placeholder=""
            variant="filled"
            value={p_revisao}
            onChange={handleChange}
          />
        </Box>

        <Box>
          <FormLabel htmlFor="u_revisao">Última Revisão:</FormLabel>
          <Input
            id="u_revisao"
            name="u_revisao"
            data-object="Carro"
            placeholder=""
            variant="filled"
            value={u_revisao}
            onChange={handleChange}
          />
        </Box>

        <Box>
          <FormLabel htmlFor="u_troca_pneu">Última troca de pneu:</FormLabel>
          <Input
            id="u_troca_pneu"
            name="u_troca_pneu"
            data-object="Carro"
            placeholder=""
            variant="filled"
            value={u_troca_pneu}
            onChange={handleChange}
          />
        </Box>

        <Box>
          <FormLabel htmlFor="u_km_registrado">Último KM Registrado:</FormLabel>
          <Input
            id="u_km_registrado"
            name="u_km_registrado"
            data-object="Carro"
            placeholder=""
            variant="filled"
            value={u_km_registrado}
            onChange={handleChange}
          />
        </Box>

        <Box>
          <FormLabel htmlFor="filial">Filial:</FormLabel>
          <Select
            id="filial"
            name="filial"
            data-object="Carro"
            variant="filled"
            defaultValue={filial}
            onChange={handleChange}
          >
            <option>{filialId}</option>
          </Select>
        </Box>

        <Box>
          <FormLabel htmlFor="status">Status:</FormLabel>
          <Select
            id="status"
            name="status"
            data-object="Carro"
            variant="filled"
            value={status}
            onChange={handleChange}
          >
            <option value="Ativo">Ativo</option>
            <option value="Inativo">Inativo</option>
            <option value="Manutenção">Manutenção</option>
          </Select>
        </Box>

        <Box py={10}>
          <Text mb="8px">Observação:</Text>
          <Textarea
            name="obs"
            placeholder="Coloque uma obsevação se necessário"
            size="sm"
            value={obs}
            onChange={handleChange}
          />
        </Box>
      </Stack>
      {isDisabled ? (
        <IconButton
          width={"100%"}
          colorScheme="green"
          aria-label="Sucesso"
          size="lg"
          icon={<CheckIcon />}
        />
      ) : (
        <Button
          width={"100%"}
          colorScheme="blue"
          onClick={updateCar}
          type="submit"
          disabled={isDisabled}
        >
          ATUALIZAR
        </Button>
      )}
    </>
  );
};

export default EditCar;
